import React from 'react';
import { FormattedMessage } from 'react-intl';
import { MenuItem } from '@material-ui/core';

const TAB_OPENED = {
    ZERO: 0,
    ONE: 1,
};

type GuideListItemGeneralMenuItemsProps = {
    onDuplicateGuide: React.ComponentProps<typeof MenuItem>['onClick'];
    handleUpdateState: (arg: unknown) => React.ComponentProps<typeof MenuItem>['onClick'];
};

const GuideListItemGeneralMenuItems = ({
    handleUpdateState,
    onDuplicateGuide,
}: GuideListItemGeneralMenuItemsProps): React.ReactElement => (
    <>
        <MenuItem
            id="yeself-menu-item"
            onClick={handleUpdateState({
                showPublishOptions: true,
                showGuideDetail: false,
                showActionsMenu: false,
                tabOpened: TAB_OPENED.ZERO,
            })}
        >
            <FormattedMessage
                id="Guides.menuItem.publishToEnv"
                defaultMessage="Publish to different environment"
            />
        </MenuItem>
        <MenuItem id="yeself-menu-item" onClick={onDuplicateGuide}>
            <FormattedMessage id="Guides.menuItem.duplicateGuide" defaultMessage="Duplicate guide" />
        </MenuItem>

        <MenuItem
            id="yeself-menu-item"
            onClick={handleUpdateState({
                showPublishOptions: false,
                showGuideDetail: true,
                showActionsMenu: false,
                menuAnchorEl: null,
                tabOpened: TAB_OPENED.ONE,
                editGuide: false,
            })}
        >
            <FormattedMessage
                id="Guides.pluginSetup.button.showConf"
                defaultMessage="Show configuration"
            />
        </MenuItem>

        <MenuItem
            id="yeself-menu-item"
            onClick={handleUpdateState({
                showPublishOptions: false,
                showGuideDetail: true,
                showActionsMenu: false,
                menuAnchorEl: null,
                tabOpened: TAB_OPENED.ZERO,
                editGuide: false,
            })}
        >
            <FormattedMessage id="Guides.pluginSetup.button.details" defaultMessage="Details" />
        </MenuItem>
    </>
);

export default GuideListItemGeneralMenuItems;
